module.exports = __webpack_public_path__ + "img/cmb2020-gold-medal.57776dfd.png";